import { useMemo } from 'react'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../../common/html/element'
import { ScrollComponent } from '../../../../../../common/scrollComponent'
import { PortfolioItem } from './PortfolioItem'

export const PortfolioList = ({ textSearch, savedPortfolioList }) => {
  const getData = useMemo(() => {
    if (textSearch) {
      return savedPortfolioList.filter((item) =>
        item.label.toUpperCase().includes(textSearch.toUpperCase()),
      )
    } else {
      return savedPortfolioList
    }
  }, [textSearch, JSON.stringify(savedPortfolioList)])

  return (
    <Element
      className="flexColumn flex1"
      style={{
        marginTop: 12,
        borderWidth: 1,
        borderColor: '#D5D5D5',
        borderStyle: 'solid',
      }}
    >
      <Element
        style={{
          fontSize: 14,
          padding: '2px 12px',
          backgroundColor: '#D5D5D5',
        }}
      >
        <Translate value="companyAnalysis.peerAnalysis.PORTFOLIO_NAME" />
      </Element>

      <div className="flex1">
        <ScrollComponent>
          {getData.map((item, index) => (
            <PortfolioItem key={index} data={item} index={index} />
          ))}
        </ScrollComponent>
      </div>
    </Element>
  )
}
